<script>
  export let name = '';
  export let logoSrc = '';
  export let logoText = '';
  export let href = '';
  export let featured = false;
  export let logoHeight = '';
  export let invert = false;

  $: className = `partner-logo-card${featured ? ' featured' : ''}${invert ? ' invert' : ''}`;
  $: imageStyle = logoHeight ? `height: ${logoHeight};` : '';
</script>

{#if href}
  <a class={className} href={href} target="_blank" rel="noreferrer" aria-label={name}>
    {#if logoSrc}
      <img src={logoSrc} alt={name} loading="lazy" style={imageStyle}>
    {:else}
      <span>{logoText || name}</span>
    {/if}
  </a>
{:else}
  <div class={className} aria-label={name}>
    {#if logoSrc}
      <img src={logoSrc} alt={name} loading="lazy" style={imageStyle}>
    {:else}
      <span>{logoText || name}</span>
    {/if}
  </div>
{/if}

<style>
  .partner-logo-card {
    display: flex;
    height: 123px;
    align-items: center;
    justify-content: center;
    padding: 24px 48px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-radius: 16px;
    background: #000000;
    color: inherit;
    text-decoration: none;
    box-sizing: border-box;
    transition: border-color 160ms ease;
  }

  a.partner-logo-card:hover,
  a.partner-logo-card:focus-visible {
    border-color: #e7b962;
    outline: none;
  }

  .featured {
    min-height: 170px;
    padding: 48px;
    border-width: 1px;
    border-color: #ffa800;
  }

  img {
    display: block;
    width: 100%;
    max-width: 100%;
    height: 75px;
    object-fit: contain;
  }

  /* Тёмный лого на чёрной карточке — инвертируем в белый */
  .invert img {
    filter: invert(1);
  }

  span {
    color: #21c547;
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .featured img {
    height: 170px;
    max-height: 170px;
  }

  .featured span {
    font-size: 40px;
  }

  @media (max-width: 1279px) {
    .partner-logo-card {
      min-height: 123px;
      padding: 24px 48px;
    }

    .featured {
      min-height: 154px;
      padding: 48px;
    }

    .featured span {
      font-size: 40px;
    }
  }

  @media (max-width: 767px) {
    .partner-logo-card {
      min-height: 70px;
      padding: 16px;
    }

    .featured {
      min-height: 113px;
      padding: 32px;
    }

    img {
      height: 40px;
    }

    span {
      font-size: 11px;
    }

    .featured img {
      height: 54px;
    }

    .featured span {
      font-size: 24px;
    }
  }
</style>
